<template>
  <div class="main" :class="{ active: isShow }">
    <div>
      <img class="bg" src="@/assets/images/download/download.png" alt="" />
    </div>
    <div class="download">
      <img @click="clickDownload" src="@/assets/images/download/anniu.png" alt="" />
    </div>
    <div class="logo">
      <img class="logo-img" src="@/assets/images/download/logo.png" alt="" />
    </div>
    <div class="info">
      “惠姑苏”基于网格化管理服务理念，以居住、学习、工作在姑苏区以及来苏旅游的人群和在姑苏区注册的企业为服务对象，紧紧围绕被服务对象在日常生活、文化教育、体育健康、交通出行、就业服务和企业服务等方面的需求，是为用户提供统一汇聚的在线查询、办事、咨询、建议和投诉等各类公共服务和政务服务的电子信息平台。
    </div>
    <img v-show="isShow" src="@/assets/images/download/float_1.png" class="overlay" alt="" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false
    }
  },
  // components: {
  // },
  created() {
    // alert('xx')
    // let ua = window.GSApi.browser.userAgent()
    // console.log(ua)
  },
  computed: {},
  methods: {
    clickDownload() {
      var u = navigator.userAgent
      var wx = /MicroMessenger/gi.test(u)
      console.log(wx)
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      console.log(isiOS)
      console.log(isAndroid)
      // 先判断是否ios环境
      if (isiOS) {
        window.location.href = 'https://apps.apple.com/cn/app/id1550735040'
      } else {
        // 判断微信
        if (wx) {
          this.isShow = true
        } else {
          window.location.href = 'https://res.gususerv.com/apk/huigusu_latest.apk'
        }
      }
    },
    /** 字符串转16进制 */
    strToHexCharCode(str) {
      if (str === '') return ''
      var hexCharCode = []
      for (var i = 0; i < str.length; i++) {
        hexCharCode.push(str.charCodeAt(i).toString(16))
      }
      return hexCharCode.join('')
    }
  }
}
</script>
<style lang="stylus" scoped>
.main {
  text-align: center;
  position: relative;
  &.active {
    height 100%
    overflow hidden
  }
  .overlay {
    width: 100%;
    position absolute
    left 0
    top 0
    bottom 0
    right 0
    z-index 99
    height 100%
  }
}
.bg {
  height: 900px;
}
.logo-img {
  width: 425px;
  height: 130px;
}
.log {
  position: relative;
  width: 100%;
  height: 130px;
}
.info {
  margin: 60px;
  text-align: left;
  width: 630px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 54px;
  margin-bottom: 150px;
}
.download {
  background: #2957a5;
  position: relative;
  bottom: 0px;
  width: 100%;
  height: 150px;
}
.download img {
  margin: 31px 0px;
  width: 350px;
  height: 88px;
}
</style>
